export default "__VITE_ASSET__CGgOjcQ$__"